<script>
import Modal from "@/components/_Shared/Modal";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Modal
  },

  data() {
    return {
      map: null,
      loader: false,
      changed: false,
      newLocation: null
    };
  },
  computed: {
    ...mapState("newAddress", ["location"])
  },
  methods: {
    ...mapActions("newAddress", ["setLocation", "setAddressComponents"]),

    createMap() {
      try {
        var element = document.getElementById("map");
        var options = {
          zoom: 17,
          center: this.location,
          disableDefaultUI: true
        };

        this.map = new google.maps.Map(element, options);
        this.map.addListener("dragend", () => (this.changed = true));
      } catch (e) {
        this.$toast.error("Erro ao criar o mapa!");
      }
    },

    getNewLocation() {
      let geocoder = new google.maps.Geocoder();

      geocoder.geocode({ latLng: this.map.center }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK && results[0])
          this.newLocation = results[0];
      });
    },

    submit() {
      this.loader = true;

      try {
        if (this.changed) this.getNewLocation();
        else this.$emit("next");
      } catch (e) {
        this.$toast.error("Erro ao confirmar a localização!");
      }
    }
  },

  watch: {
    async newLocation(newLocation) {
      try {
        await this.setLocation(newLocation.geometry.location);
        await this.setAddressComponents(newLocation.address_components);
        this.$emit("next");
      } catch (e) {
        this.$toast.error(e);
      }

      this.loader = false;
    }
  },

  mounted() {
    this.createMap();
  }
};
</script>

<template>
  <modal
    title="CONFIRME A LOCALIZAÇÃO"
    subtitle="Confirme a localização do endereço no mapa."
    size="md"
  >
    <template slot="body">
      <section>
        <div id="map" class="google-map"></div>
        <div class="pin"></div>
        <div class="map-title">confirme sua localização</div>

        <div class="button-group">
          <div class="btn bg-pink radius" @click="$emit('prev')">voltar</div>
          <div
            class="btn bg-purple radius"
            :class="{ 'btn--loading': loader }"
            @click="submit()"
          >
            <span>confirmar</span>
          </div>
        </div>
      </section>
    </template>
  </modal>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.btn {
  box-shadow: var(--shadow);
}

.button-group {
  display: flex;
  position: absolute;
  top: calc(50vh + 200px);
  z-index: 99999;
}

.radius {
  border-radius: 50px;
}

.map-title {
  position: absolute;
  top: calc(50vh - 200px);
  padding: 15px 20px;
  border-radius: 50px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 400;
  box-shadow: var(--shadow);
  z-index: 99999;
  background-color: var(--pink);
  color: #fff;
}

.google-map {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  background: gray;
  border-radius: 5px;
  z-index: 1 !important;
  border-radius: 10px;
}

.pin {
  position: absolute;
  left: calc(50% - 25px);
  top: calc(50% - 50px);
  background: url("/static/pin-map.png") no-repeat center;
  background-size: contain;
  height: 50px;
  width: 50px;
  z-index: 99999;
}

@media (max-width: 420px) {
  .map-title {
    top: 20px;
  }

  .button-group {
    top: auto;
    bottom: 20px;
  }

  .google-map {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
    z-index: 1 !important;
  }
}

@media (max-height: 660px) {
  .map-title {
    top: 20px;
  }

  .button-group {
    top: auto;
    bottom: 20px;
  }

  .google-map {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
    z-index: 1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/NewAddress/PinConfirmation.vue